<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--action_add_tag">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">ADD TAG</div>
        <div class="workflow-node__title">{{ data?.config?.tag_name || 'Add Tag' }}</div>
        <Handle type="source" :position="Position.Bottom" />
    </div>
</template>
